export default __webpack_public_path__ + "static/media/6.733de58b.mp3";